var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragHolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0032c5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.391)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 22) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 0.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 18.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 9.391)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 22) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 0.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 18.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 9.391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHolderIcon);
export default __webpack_public_path__ + "static/media/drag-holder-icon.6ee6a32ec6012636e2f6493bed0d8b55.svg";
export { ForwardRef as ReactComponent };